import React from "react";
import { Text } from "@mantine/core";

function Support() {
  const pagagraphStyle = "my-6";
  const titleStyle = "text-xl tracking-wide mb-3";
  const contentStyle = "text-sm tracking-wider mb-3";
  return (
    <div className="w-full sm:h-full flex justify-center p-2">
      <div className="w-[88%] sm:w-[65%] mt-[5vh] sm:mt-0 sm:flex sm:flex-col sm:justify-center font-inter">
        <div className="mb-10">
          <Text
            component="h1"
            className="text-xl sm:text-[1.75rem] tracking-wide my-4"
            fw={600}
          >
            CÁCH TÌM SỐ CID CỦA VIETMAP S1
          </Text>
          <Text className="text-sm tracking-wide" fw={400}>
            Hướng dẫn cách tìm số CID của VIETMAP S1
          </Text>
        </div>
        <div className={pagagraphStyle}>
          <Text component="h2" className={titleStyle} fw={600}>
            BƯỚC 1
          </Text>
          <Text component="p" className={contentStyle} fw={400}>
            t is a long established fact that a reader will be distracted by the
            readable content of a page when looking at its layout.
          </Text>
          <Text component="p" className={contentStyle} fw={400}>
            he point of using Lorem Ipsum is that it has a more-or-less normal
            distribution of letters, as opposed to using 'Content here, content
            here', making it look like readable English. Many desktop publishing
            packages and web page editors now use Lorem Ipsum as their default
            model text, and a search for 'lorem ipsum' will uncover many web
            sites still in their infancy.
          </Text>
        </div>
        <div className={pagagraphStyle}>
          <Text component="h2" className={titleStyle} fw={600}>
            BƯỚC 2
          </Text>
          <Text component="p" className={contentStyle} fw={400}>
            Various versions have evolved over the years, sometimes by accident,
            sometimes on purpose (injected humour and the like).
          </Text>
          <Text component="p" className={contentStyle} fw={400}>
            There are many variations of passages of Lorem Ipsum available, but
            the majority have suffered alteration in some form, by injected
            humour, or randomised words which don't look even slightly
            believable.
          </Text>
        </div>
        <div className={pagagraphStyle}>
          <Text component="h2" className={titleStyle} fw={600}>
            BƯỚC 3
          </Text>
          <Text component="p" className={contentStyle} fw={400}>
            Contrary to popular belief, Lorem Ipsum is not simply random text.
            It has roots in a piece of classical Latin literature from 45 BC,
            making it over 2000 years old.
          </Text>
          <Text component="p" className={contentStyle} fw={400}>
            Richard McClintock, a Latin professor at Hampden-Sydney College in
            Virginia, looked up one of the more obscure Latin words,
            consectetur, from a Lorem Ipsum passage, and going through the cites
            of the word in classical literature, discovered the undoubtable
            source.
          </Text>
        </div>
      </div>
    </div>
  );
}

export default Support;
